// extracted by mini-css-extract-plugin
export default {"FormGrid":"AlwinParameters_FormGrid__vpj2n"};